export default __webpack_public_path__ + "static/media/wallet-connect.a7c0792a.svg";